import {
  Box,
  Display,
  FlexDirection,
  Color,
  FontFamily,
  StepperButton,
  Text,
  AlignItems,
} from '@gousto-internal/citrus-react'
import React from 'react'
import { Surcharge } from '../Surcharge/Surcharge'

type StepperAddButtonProps = {
  isNegativeSurcharge?: boolean
  isOutOfStock: boolean
  onClickAdd: (isFirstInBatchOfSameRecipes: boolean) => void
  onClickRemove: () => void
  quantity: number
  reachedLimit: boolean
  surchargeLabel: string | null
}

export const StepperAddButton = ({
  isNegativeSurcharge,
  isOutOfStock,
  onClickAdd,
  onClickRemove,
  quantity,
  reachedLimit,
  surchargeLabel,
}: StepperAddButtonProps) => {
  return (
    <StepperButton
      fullWidth
      increment={() => onClickAdd(false)}
      decrement={onClickRemove}
      count={1}
      disableIncrement={reachedLimit || isOutOfStock}
      disableDecrement={isOutOfStock}
    >
      <Box
        alignItems={AlignItems.Center}
        display={Display.Flex}
        flexDirection={[FlexDirection.Column, FlexDirection.Row]}
        gap={[0, 2]}
      >
        <Text
          color={Color.ColdGrey_800}
          fontFamily={FontFamily.Bold}
          size={3}
        >{`${quantity} added`}</Text>
        <Surcharge label={surchargeLabel} variant={isNegativeSurcharge ? 'value' : 'light'} />
      </Box>
    </StepperButton>
  )
}
